module.exports = __webpack_public_path__ + "img/collapse icon.48baadf0.svg";